"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMetadata = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = _interopRequireDefault(require("lodash/constant"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MetadataContext = /*#__PURE__*/_react["default"].createContext({
  get: (0, _constant["default"])({})
});

var useMetadata = function useMetadata() {
  var _useContext = (0, _react.useContext)(MetadataContext),
      get = _useContext.get;

  return [get];
};

exports.useMetadata = useMetadata;

var valueFromProp = function valueFromProp(p) {
  return (0, _isFunction["default"])(p) ? p() : p;
};

var Metadata = function Metadata(_ref) {
  var value = _ref.value,
      children = _ref.children;
  var valRef = (0, _react.useRef)(value);
  (0, _react.useEffect)(function () {
    valRef.current = value;
  }, [value]);

  var _useContext2 = (0, _react.useContext)(MetadataContext),
      ctxGet = _useContext2.get;

  var get = (0, _react.useCallback)(function () {
    return _objectSpread(_objectSpread({}, ctxGet()), valueFromProp(valRef.current));
  }, [ctxGet]);
  var val = (0, _react.useMemo)(function () {
    return {
      get: get
    };
  }, [get]);
  return /*#__PURE__*/_react["default"].createElement(MetadataContext.Provider, {
    value: val
  }, children);
};

Metadata.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  children: _propTypes["default"].any.isRequired
};
var _default = Metadata;
exports["default"] = _default;